module.exports = __webpack_public_path__ + "img/default_person.cbf5e4e0.png";